import UserHelper from "@/Components/Base/UserHelper";
import Search from "@/Components/Input/Search";
import useLiveSearch from "@/shared/atoms/useLiveSearch";
import useCommon from "@/shared/hooks/useCommon";

const LiveSearch = () => {
  const t = useCommon();
  const [search, setSearch] = useLiveSearch();
  return (
    <div className="-mb-4 w-full max-w-full md:max-w-[40rem]">
      <UserHelper>
        <Search
          onDeleteClick={() => setSearch("")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t("orders_live.search")}
        />
      </UserHelper>
    </div>
  );
};

export default LiveSearch;
